export const DRAWERS = {
  PLANNED_ACTIONS_DRAWER: 'PLANNED_ACTIONS_DRAWER',
  TENANTS_WITH_REMINDERS_DRAWER: 'TENANTS_WITH_REMINDERS_DRAWER',
  COVERED_RISKS_REMINDER_DRAWER: 'COVERED_RISKS_REMINDER_DRAWER',
  ROUTINE_COMPLETED_TASKS_DRAWER: 'ROUTINE_COMPLETED_TASKS_DRAWER',
  REMINDER_TEMPLATE_VIEW_DRAWER: 'REMINDER_TEMPLATE_VIEW_DRAWER',
  ATTENTION_DRAWER: 'ATTENTION_DRAWER',
  REMINDER_ACTION_DRAWER: 'REMINDER_ACTION_DRAWER',
  REMINDER_ACTIONS_DATE_LIST_DRAWER: 'REMINDER_ACTIONS_DATE_LIST_DRAWER',
  REMINDER_PREVIEW_DRAWER: 'REMINDER_PREVIEW_DRAWER',
  COMPLETE_PHONE_DRAWER: 'COMPLETE_PHONE_DRAWER',
  TENANT_CONNECTIONS_DRAWER: 'TENANT_CONNECTIONS_DRAWER',
  NOTIFICATIONS_DRAWER: 'NOTIFICATIONS_DRAWER',
} as const;
